import React, { useState } from 'react';
const NewsletterCard = ({ newsletterGuid, siteId, newsletterConfig, }) => {
    const [apiResponse, setApiResponse] = useState(null);
    const [email, setEmail] = useState('');
    const [emailIsValid, setEmailIsValid] = useState(true);
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [termsIsValid, setTermsIsValid] = useState(true);
    // Check we have valid configs
    if (!newsletterGuid || !newsletterConfig) {
        return null;
    }
    const { buttonText, newsletterHeading, newsletterIntro, subscriptionSuccess, termsText, termsErrorMessage, textBoxErrorMessage, textBoxPlaceholder, } = newsletterConfig;
    async function handleSubscribe() {
        if (email.length === 0) {
            setEmailIsValid(false);
            return;
        }
        else {
            setEmailIsValid(true);
        }
        if (!!termsText && !acceptedTerms) {
            setTermsIsValid(false);
            return;
        }
        else {
            setTermsIsValid(true);
        }
        const subscriptionInfo = {
            SiteId: siteId,
            Newsletter: newsletterGuid,
            SubscriberEmail: email,
        };
        const subscriptionInfoJson = JSON.stringify(subscriptionInfo);
        const response = await fetch(`/api/newsletter/signup/`, {
            method: 'post',
            headers: new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }),
            body: subscriptionInfoJson,
        });
        const { ok, status } = response;
        if (status === 400) {
            setEmailIsValid(false);
        }
        setApiResponse({
            ok,
            status,
        });
    }
    // Check we have all the minimum props we need
    if (!newsletterHeading || !buttonText) {
        return null;
    }
    const success = apiResponse?.ok;
    return (React.createElement("div", { className: "grid-column" },
        React.createElement("div", { className: "cta cta--newsletter cta--blue cta--small" },
            React.createElement("svg", { className: "icon-svg icon-ring", viewBox: "0 0 24 24" },
                React.createElement("use", { xlinkHref: "/src/img/svg/icon-ring.svg#icon-ring" })),
            React.createElement("div", { className: "cta__inner grid-container grid-container--half" },
                React.createElement("div", { className: "cta__left grid-column" },
                    newsletterHeading && React.createElement("h3", { className: "cta__title" }, newsletterHeading),
                    !success && newsletterIntro && React.createElement("p", { className: "cta__intro" }, newsletterIntro),
                    success && subscriptionSuccess && React.createElement("p", { className: "cta__intro" }, subscriptionSuccess)),
                React.createElement("div", { className: "cta__right grid-column" }, !success && (React.createElement("div", { className: "cta__form-holder" },
                    React.createElement("div", { className: "cta__form-row" },
                        React.createElement("div", { className: "cta__form-inline" },
                            React.createElement("div", { className: "form-input-container cta__form-text-input" },
                                React.createElement("input", { className: `form-input ${emailIsValid ? 'form-input--text' : 'form-input--error'}`, type: "text", value: email, onChange: (event) => {
                                        setEmail(event.target.value);
                                    }, onKeyDown: (event) => {
                                        if (event.keyCode === 13)
                                            handleSubscribe();
                                    }, placeholder: textBoxPlaceholder ?? '' }),
                                React.createElement("span", { className: "form-label form-label--error" }, textBoxErrorMessage)),
                            termsText && (React.createElement("div", { className: "form-input-container form-input-container--clickable" },
                                React.createElement("input", { type: "checkbox", id: "checkbox", name: "checkbox", className: `form-clickable form-clickable--checkbox ${termsIsValid ? '' : 'form-clickable--error'}`, checked: acceptedTerms, onChange: (event) => {
                                        if (event.target instanceof HTMLInputElement) {
                                            setAcceptedTerms(event.target.checked);
                                        }
                                    } }),
                                React.createElement("label", { className: "form-label form-clickable--error-white", htmlFor: "checkbox", dangerouslySetInnerHTML: { __html: termsText } }),
                                !termsIsValid && termsErrorMessage && (React.createElement("span", { className: "form-label form-label--error form-label--error-background" }, termsErrorMessage)))),
                            React.createElement("input", { className: "btn cta__form-input-btn", type: "submit", value: buttonText, onClick: (event) => {
                                    event.preventDefault();
                                    handleSubscribe();
                                }, onKeyDown: (event) => {
                                    event.preventDefault();
                                    if (event.keyCode === 13)
                                        handleSubscribe();
                                } }))),
                    React.createElement("div", { className: "cta__form-row" }))))))));
};
export default NewsletterCard;
